jQuery(document).ready(function(){
    function showRecoverPasswordFormAccount(event) {
      event && event.preventDefault();
      jQuery('#recover_password1').show();
      jQuery('#customer_login1').hide();
      window.location.hash = '#recover';
    }
    function hideRecoverPasswordFormAccount(event) {
      event && event.preventDefault();
      jQuery('#recover_password1').hide();
      jQuery('#customer_login1').show();
      $('.showRecoverPasswordForm').focus();   
      if(window.location.hash === '#recover') window.location.hash = '';
    }
    if(window.location.hash === '#recover') showRecoverPasswordFormAccount();
    jQuery('.showRecoverPasswordForm').on('click',showRecoverPasswordFormAccount)
    jQuery('.hideRecoverPasswordForm').on('click',hideRecoverPasswordFormAccount)
    jQuery('.wrapper-login-customer .wrapper-content .col-left .errors').attr({
      'role':'alert',
      'aria-live':'assertive'
    });
});
  
  /*
    Show/hide the recover password form when requested.
    I'd suggest using some CSS3 transitions to make this change look cool,
    but this gets the job done for now.
  */
  jQuery('#customer_login').each(function(i,e){
    jQuery(this).addClass('custom_login-class');
    jQuery(this).attr('id','customer_login'+(i+1))
  })
  jQuery('#create_customer').each(function(i,e){
    jQuery(this).addClass('create_customer-class');
    jQuery(this).attr('id','create_customer'+(i+1))
  })
  jQuery('#recover_password').each(function(i,e){
    jQuery(this).addClass('recover_password-class');
    jQuery(this).attr('id','recover_password'+(i+1))
  })
  function showRecoverPasswordForm() {
    jQuery('.recover_password-class').show();
    jQuery('.custom_login-class').hide();
  }

  function hideRecoverPasswordForm() {
    jQuery('.recover_password-class').hide();
    jQuery('.custom_login-class').show();
  }

  // Allow deep linking to the recover password form
  if (window.location.hash == '#recover') {
    showRecoverPasswordForm() 
  }